import { render } from "./LogoReversed.svg?vue&type=template&id=3c342cea"
const script = {}
script.render = render

export default script